import React from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";
const Main = () => {
  const navigate = useNavigate();

  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* 로고 영역 */}
        <h1 style={{ fontSize: "2rem", fontWeight: "bold", color: "#333", marginBottom: "5px" }}>
          🧅 겹겹일지 🧅
        </h1>
        <p style={{ fontSize: "1rem", fontWeight: "bold", color: "#666", marginBottom: "30px" }}>
          -쌓아가는 나의 기록-
        </p>

        <p style={{ marginBottom: "40px", color: "#555" }}>
          아래 버튼을 눌러 로그인 또는 회원가입을 진행해주세요.
        </p>

        {/* 버튼 영역 */}
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {/* 보라색 로그인 버튼 */}
          <button 
            onClick={() => navigate("/login")}
            style={{
              width: "100%",
              padding: "15px",
              backgroundColor: "#A5668B", 
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: "bold",
              cursor: "pointer"
            }}
          >
            로그인 페이지로 이동
          </button>
          
          {/* 연두색 회원가입 버튼 */}
          <button 
            onClick={() => navigate("/register")}
            style={{
              width: "100%",
              padding: "15px",
              backgroundColor: "#92D050", 
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: "bold",
              cursor: "pointer"
            }}
          >
            회원가입 페이지로 이동
          </button>
        </div>
      </div>
    </div>
  );
};

export default Main;